import React from 'react';

import { ModalButton } from './ModalButton';
import { ModalContext } from './ModalContext';

interface IModalButtonProps {
    variant: string;
    disableOnSubmit: boolean;
}

export const ModalCancelButton = ({disableOnSubmit, children, variant}: React.PropsWithChildren<IModalButtonProps>) => {
    const {onCancel} = React.useContext(ModalContext);

    return (
        <ModalButton
            className="btn-xl"
            variant={variant}
            onClick={onCancel}
            disableOnSubmit={disableOnSubmit}
        >
            {children}
        </ModalButton>
    );
};

ModalCancelButton.defaultProps = {
    variant: 'default',
    disableOnSubmit: true,
};
